import 'bootstrap/js/dist/collapse';
import { getText, appendText } from '../../assets/js/text-renderer';

import './intelek-landing.scss';
import '../shared/landing-hero.scss';
import '../../assets/js/accordion-image';
import '../shared/dynamic-tabs/dynamic-tabs.js';
import '../shared/cta/cta';
import '../shared/faqs/faqs';

document.addEventListener('DOMContentLoaded', async () => {
  if (
    DEVELOPMENT || (
    window['__PRERENDER_INJECTED'] && 
    window['__PRERENDER_INJECTED'].render_text)
  ) await loadText();
});

const loadText = async () => {
  const data = await getText('platform/intelek-landing')
  const content = data.stories[0].content;
  const ctaButtonsContent = await getText('platform/shared/cta-buttons');
  const ctaButtons = ctaButtonsContent.stories[0].content;

  setHeroContent(content, ctaButtons);
  setBenefitsContent(content);
  setPlatformContent(content);
  setTechnologyContent(content);
  setUserContent(content);
  setEpilogueContent(content);
  await setFaqsContent(content);
  await setCustomCtaContent();

  window.dispatchEvent(new CustomEvent('rendered-text', { detail: 'keywords' }));
  window.dispatchEvent(new CustomEvent('rendered-text', { detail: 'content' }));
};

function setHeroContent(content, ctaButtons) {
  appendText(content.promotion_alert, 'promotion-alert');
  appendText(content.hero_title, 'hero-title');
  appendText(content.hero_description, 'hero-description');
  appendText(ctaButtons.start_trial_btn, 'hero-cta-trial-button');
  appendText(ctaButtons.book_demo_btn, 'hero-cta-demo-button');
  appendText(content.featured_companies, 'featured-companies');
};

function setBenefitsContent(content) {
  appendText(content.benefits_header, 'benefits-header');
  appendText(content.benefits_items[0].title, 'benefit-item-title-0');
  appendText(content.benefits_items[0].description, 'benefit-item-description-0');
  appendText(content.benefits_items[1].title, 'benefit-item-title-1');
  appendText(content.benefits_items[1].description, 'benefit-item-description-1');
  appendText(content.benefits_items[2].title, 'benefit-item-title-2');
  appendText(content.benefits_items[2].description, 'benefit-item-description-2');
};

function setPlatformContent(content) {
  appendText(content.platform_header, 'platform-header');

  // Collector content
  appendText(content.platform_items[0].title, 'collector-tab');
  appendText(content.platform_items[0].description, 'collector-text');
  const collectorTabContent = document.getElementById('collector-text');
  const collectorCtaContent = document.getElementById('collector-cta');
  const collectorCtaClone = document.importNode(collectorCtaContent.content, true);
  collectorTabContent.appendChild(collectorCtaClone);
  appendText(content.platform_cta_book_demo, 'platform-cta-book-demo-0');
  appendText(content.platform_cta_more_info, 'platform-cta-more-info-0');

  // Compute content
  appendText(content.platform_items[1].title, 'compute-tab');
  appendText(content.platform_items[1].description, 'compute-text');
  const computeTabContent = document.getElementById('compute-text');
  const computeCtaContent = document.getElementById('compute-cta');
  const computeCtaClone = document.importNode(computeCtaContent.content, true);
  computeTabContent.appendChild(computeCtaClone);
  appendText(content.platform_cta_book_demo, 'platform-cta-book-demo-1');
  appendText(content.platform_cta_more_info, 'platform-cta-more-info-1');

  // Smart Analytics content
  appendText(content.platform_items[2].title, 'analytics-tab');
  appendText(content.platform_items[2].description, 'analytics-text');
  const analyticsTabContent = document.getElementById('analytics-text');
  const analyticsCtaContent = document.getElementById('analytics-cta');
  const analyticsCtaClone = document.importNode(analyticsCtaContent.content, true);
  analyticsTabContent.appendChild(analyticsCtaClone);
  appendText(content.platform_cta_book_demo, 'platform-cta-book-demo-2');
  appendText(content.platform_cta_more_info, 'platform-cta-more-info-2');
};

function setTechnologyContent(content) {
  appendText(content.technology_header, 'technology-header');
  appendText(content.technology_items[0].text, 'technology-item-0');
  appendText(content.technology_items[1].text, 'technology-item-1');
  appendText(content.technology_items[2].text, 'technology-item-2');
};

function setUserContent(content) {
  appendText(content.users_header, 'users-header');
  appendText(content.users_items[0].title, 'business-tab');
  appendText(content.users_items[0].description, 'business-text');
  appendText(content.users_items[1].title, 'analyst-tab');
  appendText(content.users_items[1].description, 'analyst-text');
  appendText(content.users_items[2].title, 'science-tab');
  appendText(content.users_items[2].description, 'science-text');
  appendText(content.users_items[3].title, 'development-tab');
  appendText(content.users_items[3].description, 'development-text');
};

function setEpilogueContent(content) {
  appendText(content.epilogue, 'epilogue');
};

async function setFaqsContent(content) {
  const faqsData = await getText('platform/shared/faqs');
  const faqsContent = faqsData.stories[0].content;

  const faqsContainer = document.getElementById('faqs');
  const faqsEl = document.createElement('custom-faqs');

  // Set faqs title
  appendText(faqsContent.title, 'faqs-title');

  // Set faqs content
  content.FAQS.forEach((faq) => {
    const faqElement = document.createElement('li');
    faqElement.setAttribute('title', faq.title);
    faqElement.setAttribute('content', faq.text);
    faqsEl.appendChild(faqElement);
  });
  faqsContainer.appendChild(faqsEl);
  
  // Set faqs footer
  appendText(faqsContent.description, 'any_more_questions');
};

async function setCustomCtaContent() {
  const ctaData = await getText('platform/shared/cta');
  const ctaContent = ctaData.stories[0].content.block[0];

  const customCtaContainer = document.getElementById('custom-cta');
  const customCtaEl = document.createElement('custom-cta');
  customCtaEl.setAttribute('title', ctaContent.title)
  customCtaEl.setAttribute('description', ctaContent.description)
  customCtaEl.setAttribute('primary-button-text', ctaContent.btn_primary)
  customCtaEl.setAttribute('primary-button-url', '/plataforma/start-trial/')
  customCtaEl.setAttribute('secondary-button-text', ctaContent.btn_secondary)
  customCtaEl.setAttribute('secondary-button-url', '/plataforma/book-demo-form/')
  customCtaContainer.appendChild(customCtaEl);

  window.dispatchEvent(
    new CustomEvent("rendered-text", { detail: "cta" })
  );
};